import {ChangeEvent, FC, useCallback} from 'react';
import {useField} from 'formik';
import Select, {SelectProps} from '../inputs/Select';

interface SelectFieldProps extends SelectProps {
  fieldDescription?: string,
  onChangeCallback?: (value) => void,
}

const SelectField: FC<SelectFieldProps> = ({
  name,
  id,
  label,
  options,
  onFocus,
  onBlur,
  apiValidationError,
  onChangeCallback,
  size,
  disabled
}) => {
  const [
    {value},
    {error, touched},
    {setTouched, setValue}
  ] = useField(name);

  const handleChange = useCallback(({
    target: {value: newValue}
  }: ChangeEvent<HTMLSelectElement>) => {
    if (onChangeCallback) {
      return onChangeCallback(value);
    }

    setTouched(true);
    setValue(newValue);
  }, [onChangeCallback]);

  return (
    <Select
      name={name}
      id={id}
      label={label}
      options={options}
      value={value}
      onChange={handleChange}
      error={error}
      touched={touched}
      onFocus={onFocus}
      onBlur={onBlur}
      apiValidationError={apiValidationError}
      size={size}
      disabled={disabled}
    />
  );
};

export default SelectField;
